function view (path) {
  return () => import(/* webpackChunkName: 'student' */ '@/views/student/' + path + '.vue').then(m => m.default || m) // eslint-disable-line prefer-template
}

const RStudent = [
  {
    path: '/student/force-password-change',
    component: view('ForcePasswordChange'),
    name: 'student.force-password-change',
    meta: {
      middleware: ['auth', 'student'],
      breadcrumb: [
        {
          text: 'Security'
        },
        {
          text: 'Change Password',
          active: true
        }
      ]
    }
  },
  {
    path: '/student/dashboard',
    component: view('Dashboard'),
    name: 'student.dashboard',
    meta: {
      middleware: ['auth', 'student'],
      breadcrumb: [
        {
          text: 'Student'
        },
        {
          text: 'Dashboard',
          active: true
        }
      ]
    }
  },
  {
    path: '/student/appointments',
    component: view('Appointments'),
    name: 'student.appointments',
    meta: {
      middleware: ['auth', 'student'],
      breadcrumb: [
        {
          text: 'Student'
        },
        {
          text: 'Appointments',
          active: true
        }
      ]
    }
  },
  {
    path: '/student/counseling-chat',
    component: view('CounselingChat'),
    name: 'student.counseling-chat',
    meta: {
      middleware: ['auth', 'student'],
      breadcrumb: [
        {
          text: 'Student'
        },
        {
          text: 'Counseling Chat',
          active: true
        }
      ]
    }
  },
  {
    path: '/student/settings',
    component: view('account-settings/Base'),
    name: 'student.settings',
    meta: {
      middleware: ['auth', 'student'],
      breadcrumb: [
        {
          text: 'Account'
        },
        {
          text: 'Settings',
          active: true
        }
      ]
    }
  },
  {
    path: '/student/violations',
    component: view('Violations'),
    name: 'student.violations',
    meta: {
      middleware: ['auth', 'student'],
      breadcrumb: [
        {
          text: 'Student'
        },
        {
          text: 'Violations',
          active: true
        }
      ]
    }
  },
  {
    path: '/student/lost-and-found',
    component: view('LostAndFound'),
    name: 'student.lost-and-found',
    meta: {
      middleware: ['auth', 'student'],
      breadcrumb: [
        {
          text: 'Student'
        },
        {
          text: 'Lost & Found',
          active: true
        }
      ]
    }
  },
  {
    path: '/student/complaints',
    component: view('Complaints'),
    name: 'student.complaints',
    meta: {
      middleware: ['auth', 'student'],
      breadcrumb: [
        {
          text: 'Student'
        },
        {
          text: 'Complaints',
          active: true
        }
      ]
    }
  },
  {
    path: '/student/feedback',
    component: view('Feedback'),
    name: 'student.feedback',
    meta: {
      middleware: ['auth', 'student'],
      breadcrumb: [
        {
          text: 'Student'
        },
        {
          text: 'Feedback',
          active: true
        }
      ]
    }
  }
]

export default RStudent
